import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { TreeStructureData } from '.';


export class LotTrackingResponse extends GlobalResponseObject{
    data?: TreeStructureData[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //TreeStructureData
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: TreeStructureData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
